import { SubscriptionStoreState, useSubscriptionStore } from '../subscriptionStore';

export const getIsPremium = (state?: SubscriptionStoreState) => {
  const isPremium = (state ?? useSubscriptionStore.getState()).isPremium;

  if (isPremium === undefined) {
    return false;
  }

  return isPremium;
};
